import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { BackButton, Button, Title } from '../../../../components/UI/ComponentsUI';
import { validateInputsRequired } from '../../../../utils/handleChangeHooks';
import { translate, downloadFile } from '../../../../utils/util';
import TruckKanbanService from '../../../../services/TruckKanbanService';
import * as actionsTruckKanban from '../../../../actions/truckKanbanAction';
import SelectResourceMvi from './SelectResourceMvi';
import SelectItem from '../../../../components/UI/SelectItem';

const CreateMvi = (props) => {
    const hasJourney = props.location?.state?.hasJourney;
    const [model, setModel] = useState({
        vehiclePlate: '',
        driver: '',
        hasJourney: hasJourney,
        printer: props.resourceMvi?.printer
    });

    const submit = () => {
        if (validateInputsRequired("mviCreate")) {
            let labels = props.labels.map((r) => ({ id: r.id }));
            var obj = {
                ...model,
                labels
            }
            props.createdMvm(obj, (response) => {
                if (response) {
                    downloadFile(response.report, `mvi${response.mvi.id}.pdf`, "data:application/pdf", true)
                    props.addDriver(model.driver)
                    props.addVehiclePlate(model.vehiclePlate)
                    props.history.go(-1);
                }
            })
        }
    };

    const onChangeSelectDriver = (event) => {
        model.driver = event
        setModel({ ...model })
    };

    const onChangeSelectVehiclePlate = (event) => {
        model.vehiclePlate = event
        setModel({ ...model })
    };

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65" />
            <Title label={model.hasJourney ? translate("create-mvi", 'truck-kanban') : translate("create-mvi-without-journey", 'truck-kanban')} />
            <div className="container">
                <div className="card">
                    <div className="card-content" style={{ padding: '15px', paddingBlockEnd: '1px' }}>
                        <div id="mviCreate" className="col s9" style={{ paddingBottom: '5px', paddingTop: '20px' }}>
                            <div className="input-field padding col s6">
                                <SelectItem
                                    required
                                    id="driver"
                                    name="driver"
                                    label={translate("driver", 'truck-kanban')}
                                    onChange={(event) => onChangeSelectDriver(event)}
                                    defaultValue={''}
                                    placeholder={translate("placeholder.driver", 'truck-kanban')}
                                    minLength={0}
                                    data={
                                        props.drivers
                                            ? props.drivers.map((i) => {
                                                return { id: i, text: i };
                                            })
                                            :
                                            []} />
                            </div>
                            <div className="input-field padding col s6">
                                <SelectItem
                                    required
                                    id="vehiclePlate"
                                    name="vehiclePlate"
                                    label={translate("vehicle-plate", 'truck-kanban')}
                                    onChange={(event) => onChangeSelectVehiclePlate(event)}
                                    onChangeData={onChangeSelectVehiclePlate}
                                    placeholder={translate("placeholder.vehicle-plate", 'truck-kanban')}
                                    defaultValue={''}
                                    minLength={0}
                                    data={
                                        props.vehiclePlates
                                            ? props.vehiclePlates.map((i) => {
                                                return { id: i, text: i };
                                            })
                                            : []} />
                            </div>
                        </div>
                        <SelectResourceMvi onChangePrinter={(printer) => {
                            model.printer = printer;
                            setModel({ ...model })
                        }} />
                        <div style={{ marginTop: '10px' }}>
                            {props.labels.map((item, index) => (
                                <div key={`${item.partNumberCode} - ${index}`} style={{ marginBottom: '20px' }}>
                                    {`${item.mvmNumber} ${item.partNumberCode} - ${item.partNumberDescription}`}
                                </div>
                            ))}
                        </div>
                        <div className="row" style={{ margin: '10px 0 15px 0' }}>
                            <div className="col s12">
                                <Button onClick={submit} full="true" text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        areas: state.areaReducer.areas,
        user: state.userReducer.user,
        config: state.configReducer.config,
        labels: state.truckKanbanReducer.labels,
        resourceMvi: state.truckKanbanReducer.resourceMvi,
        resources: state.logisticsResourceReducer.list,
        drivers: state.truckKanbanReducer.drivers,
        vehiclePlates: state.truckKanbanReducer.vehiclePlates
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        createdMvm: (data, callback) => {
            dispatch(TruckKanbanService.createMvi(data, callback));
        },
        setResourceMvi: (resourceMvi) => {
            dispatch(actionsTruckKanban.setResourceMvi(resourceMvi));
        },
        addDriver: (driver) => {
            dispatch(actionsTruckKanban.AddDriver(driver));
        },
        addVehiclePlate: (vehiclePlate) => {
            dispatch(actionsTruckKanban.AddVehiclePlate(vehiclePlate));
        },

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CreateMvi));